/* Citation tools only. Static research content remains usable without JavaScript. */
(() => {
  function init(root) {
    if (root.dataset.copyReady) return;
    root.dataset.copyReady = 'true';
    const status = root.querySelector('[data-copy-status]');
    root.querySelectorAll('[data-copy-target]').forEach((button) => {
      button.hidden = false;
      button.addEventListener('click', async () => {
        const target = document.getElementById(button.dataset.copyTarget);
        if (!target) return;
        const text = target.dataset.copyText || target.textContent.trim();
        const originalLabel = button.dataset.originalLabel || button.textContent;
        button.dataset.originalLabel = originalLabel;
        let copied = false;
        try {
          await navigator.clipboard.writeText(text);
          copied = true;
        } catch (_) {
          const field = document.createElement('textarea');
          field.value = text;
          field.setAttribute('readonly', '');
          field.setAttribute('aria-label', 'Text to copy');
          field.style.cssText = 'position:fixed;left:-9999px;top:0;opacity:0;';
          document.body.appendChild(field);
          field.select();
          field.setSelectionRange(0, field.value.length);
          try { copied = document.execCommand('copy'); } catch (_) { copied = false; }
          field.remove();
          button.focus({ preventScroll: true });
        }
        clearTimeout(button.copyTimer);
        if (copied) {
          button.textContent = 'Copied ✓';
          status.textContent = 'Copied to clipboard.';
          button.copyTimer = setTimeout(() => {
            button.textContent = originalLabel;
            status.textContent = '';
          }, 1800);
        } else {
          const selection = window.getSelection();
          const range = document.createRange();
          range.selectNodeContents(target);
          selection.removeAllRanges();
          selection.addRange(range);
          status.textContent = 'The text is selected. Use your device’s Copy command to copy it.';
          button.textContent = 'Text selected';
          button.copyTimer = setTimeout(() => { button.textContent = originalLabel; }, 1800);
        }
      });
    });
  }
  document.querySelectorAll('[data-lpl-statistics]').forEach(init);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-lpl-statistics]').forEach(init);
  });
})();
